import React from 'react';
import ConfirmModal from '~/components/General/ConfirmModal';

const DeliverableContactsModal = ({
  open,
  deliverableCount,
  nonDeliverableCount,
  onContinue,
  onClose,
}) => {
  const contactSummary = (
    <>
      You have selected {deliverableCount}{' '}
      {deliverableCount === 1 ? 'Deliverable Contact' : 'Deliverable Contacts'}
      {nonDeliverableCount > 0 ? (
        <>
          {' '}
          and {nonDeliverableCount}{' '}
          {nonDeliverableCount === 1 ? 'Non-Deliverable Contact' : 'Non-Deliverable Contacts'}
        </>
      ) : null}
      . Do you want to continue?
    </>
  );

  return (
    <ConfirmModal
      openConfirmModal={{
        open,
        header: 'Place Order',
        message: contactSummary,
        handleOk: onContinue,
        handleClose: onClose,
        successButtonName: 'Continue',
        cancelButtonName: 'Cancel',
        className: 'deliverableContactsModal',
      }}
    />
  );
};

export default DeliverableContactsModal;
